// import { ColumnDef } from '@tanstack/react-table';
// import { RoleResponse } from 'pages/apps/roles/types/types';
// import dayjs from 'dayjs';
// import { faPencil, faTrash, faEye } from '@fortawesome/free-solid-svg-icons';
// import { Dropdown } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { RevealDropdownTrigger } from 'components/base/RevealDropdown';
// import RevealDropdown from 'components/base/RevealDropdown';

// const ActionCell = ({
//   row,
//   handleEditClick,
//   canEdit = false,
//   handleDeleteClick,
//   canDelete = false,
//   handleViewPermissions
// }: any) => {
//   if (!canEdit && !canDelete) {
//     return null;
//   }

//   return (
//     <RevealDropdownTrigger>
//       <RevealDropdown>
//         <>
//           {canEdit && (
//             <Dropdown.Item
//               eventKey="1"
//               onClick={() => handleViewPermissions(row.original)}
//             >
//               <FontAwesomeIcon icon={faEye} className="me-2 text-info" />
//               View Permissions
//             </Dropdown.Item>
//           )}

//           {canEdit && (
//             <>
//               <Dropdown.Divider />
//               <Dropdown.Item
//                 eventKey="2"
//                 onClick={() => handleEditClick(row?.original)}
//               >
//                 <FontAwesomeIcon
//                   icon={faPencil}
//                   className="me-2 text-primary"
//                 />
//                 Edit
//               </Dropdown.Item>
//             </>
//           )}

//           {canDelete && (
//             <>
//               {canEdit && <Dropdown.Divider />}
//               <Dropdown.Item
//                 eventKey="3"
//                 className="text-danger"
//                 onClick={() => handleDeleteClick(row?.original)}
//               >
//                 <FontAwesomeIcon icon={faTrash} className="me-2 text-danger" />
//                 Delete
//               </Dropdown.Item>
//             </>
//           )}
//         </>
//       </RevealDropdown>
//     </RevealDropdownTrigger>
//   );
// };

// export const columns = (
//   handleEditClick: (role: any) => void,
//   canEdit = false,
//   handleDeleteClick: (role: any) => void,
//   canDelete = false,
//   handleViewPermissions: (role: RoleResponse) => void
// ): ColumnDef<RoleResponse>[] => [
//   {
//     accessorKey: 'name',
//     header: 'Name',
//     cell: ({ row }) => (
//       <span style={{ whiteSpace: 'nowrap' }}>{row?.original?.name}</span>
//     )
//   },
//   {
//     accessorKey: 'description',
//     header: 'Description',
//     cell: ({ row }) => (
//       <span style={{ whiteSpace: 'nowrap' }}>
//         {row.original?.description || 'N/A'}
//       </span>
//     )
//   },
//   {
//     accessorKey: 'isSystem',
//     header: 'System Role',
//     cell: ({ row }) => (
//       <span style={{ whiteSpace: 'nowrap' }}>
//         {row.original?.isSystem ? 'Yes' : 'No'}
//       </span>
//     )
//   },
//   {
//     accessorKey: 'isDefault',
//     header: 'Default Role',
//     cell: ({ row }) => (
//       <span style={{ whiteSpace: 'nowrap' }}>
//         {row.original?.isDefault ? 'Yes' : 'No'}
//       </span>
//     )
//   },
//   {
//     accessorKey: 'createdAt',
//     header: 'Created At',
//     cell: ({ row }) => (
//       <span style={{ whiteSpace: 'nowrap' }}>
//         {dayjs(row.original?.createdAt)
//           .locale('en')
//           .format('MMM D, YYYY h:mm A')}
//       </span>
//     )
//   },
//   {
//     accessorKey: 'updatedAt',
//     header: 'Updated At',
//     cell: ({ row }) => (
//       <span style={{ whiteSpace: 'nowrap' }}>
//         {dayjs(row.original?.updatedAt)
//           .locale('en')
//           .format('MMM D, YYYY h:mm A')}
//       </span>
//     )
//   },
//   {
//     id: 'actions',
//     header: '',
//     cell: ({ row }) => (
//       <ActionCell
//         row={row}
//         handleEditClick={handleEditClick}
//         canEdit={canEdit}
//         handleDeleteClick={handleDeleteClick}
//         canDelete={canDelete}
//         handleViewPermissions={handleViewPermissions}
//       />
//     )
//   }
// ];

import { ColumnDef } from '@tanstack/react-table';
import { RoleResponse } from 'pages/apps/roles/types/types';
import dayjs from 'dayjs';
import { faPencil, faTrash, faEye } from '@fortawesome/free-solid-svg-icons';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RevealDropdownTrigger } from 'components/base/RevealDropdown';
import RevealDropdown from 'components/base/RevealDropdown';

const ActionCell = ({
  row,
  handleEditClick,
  canEdit = false,
  handleDeleteClick,
  canDelete = false,
  handleViewPermissions
}: any) => {
  if (!canEdit && !canDelete) {
    return null;
  }
  return (
    <div className="action-cell">
      <RevealDropdownTrigger>
        <RevealDropdown className="position-absolute">
          <>
            {canEdit && (
              <Dropdown.Item
                eventKey="1"
                onClick={() => handleViewPermissions(row.original)}
              >
                <FontAwesomeIcon icon={faEye} className="me-2 text-info" />
                View Permissions
              </Dropdown.Item>
            )}
            {canEdit && (
              <>
                <Dropdown.Divider />
                <Dropdown.Item
                  eventKey="2"
                  onClick={() => handleEditClick(row?.original)}
                >
                  <FontAwesomeIcon
                    icon={faPencil}
                    className="me-2 text-primary"
                  />
                  Edit
                </Dropdown.Item>
              </>
            )}
            {canDelete && (
              <>
                {canEdit && <Dropdown.Divider />}
                <Dropdown.Item
                  eventKey="3"
                  className="text-danger"
                  onClick={() => handleDeleteClick(row?.original)}
                >
                  <FontAwesomeIcon
                    icon={faTrash}
                    className="me-2 text-danger"
                  />
                  Delete
                </Dropdown.Item>
              </>
            )}
          </>
        </RevealDropdown>
      </RevealDropdownTrigger>
    </div>
  );
};
export const columns = (
  handleEditClick: (role: any) => void,
  canEdit = false,
  handleDeleteClick: (role: any) => void,
  canDelete = false,
  handleViewPermissions: (role: RoleResponse) => void
): ColumnDef<RoleResponse>[] => [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row }) => (
      <span style={{ whiteSpace: 'nowrap' }}>{row?.original?.name}</span>
    )
  },
  {
    accessorKey: 'description',
    header: 'Description',
    cell: ({ row }) => (
      <span style={{ whiteSpace: 'nowrap' }}>
        {row.original?.description || 'N/A'}
      </span>
    )
  },
  {
    accessorKey: 'isSystem',
    header: 'System Role',
    cell: ({ row }) => (
      <span style={{ whiteSpace: 'nowrap' }}>
        {row.original?.isSystem ? 'Yes' : 'No'}
      </span>
    )
  },
  {
    accessorKey: 'isDefault',
    header: 'Default Role',
    cell: ({ row }) => (
      <span style={{ whiteSpace: 'nowrap' }}>
        {row.original?.isDefault ? 'Yes' : 'No'}
      </span>
    )
  },
  {
    accessorKey: 'createdAt',
    header: 'Created At',
    cell: ({ row }) => (
      <span style={{ whiteSpace: 'nowrap' }}>
        {dayjs(row.original?.createdAt)
          .locale('en')
          .format('MMM D, YYYY h:mm A')}
      </span>
    )
  },
  {
    accessorKey: 'updatedAt',
    header: 'Updated At',
    cell: ({ row }) => (
      <span style={{ whiteSpace: 'nowrap' }}>
        {dayjs(row.original?.updatedAt)
          .locale('en')
          .format('MMM D, YYYY h:mm A')}
      </span>
    )
  },
  {
    id: 'actions',
    header: '',
    cell: ({ row }) => (
      <ActionCell
        row={row}
        handleEditClick={handleEditClick}
        canEdit={canEdit}
        handleDeleteClick={handleDeleteClick}
        canDelete={canDelete}
        handleViewPermissions={handleViewPermissions}
      />
    )
  }
];
